import { ResourceTypeAction,ResourceTypes } from './Types'
import { ResourceInitialStateType  } from './Interface'

const intialState: ResourceInitialStateType = {
    isLoading:false
}

export const resourceReducer = (state=intialState,action:ResourceTypeAction) => {

    switch(action.type){
        // case ResourceTypes.LOADING_RESOURCES:
        //     return { ...state}
        case ResourceTypes.LOAD_RESOURCES:
            return { ...state,welcome:action.payload.data}
        case ResourceTypes.LOAD_RESOURCE_DETAILS:
            return {...state,resourceItem:action.payload.data}
        default: return state 
    }
}


